import { Component, OnInit } from '@angular/core';
import { TitleWrapperService } from '../_services/title-wrapper.service';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private forcedVariant: string = 'default';
  constructor(
    public lmsUserService: LmsUserService,
    private titleService: TitleWrapperService
  ) { }

  ngOnInit() {
    this.titleService.SetTitle('Massage Therapy Continuing Education with ABMP Membership | ABMP', true);
  }

  CanSwitchVariant() {
    if (this.lmsUserService.IsLoggedIn) {
      let mbrTypes = this.lmsUserService.User.GetMemberTypes('ABMP');
      return mbrTypes.includes('PAC STAFF');
    }
    return false;
  }

  GetLandingPageVariant() {
    if (this.CanSwitchVariant && this.forcedVariant != 'default') {
      return this.forcedVariant;
    }
    let variant = this.lmsUserService.IsLoggedIn ? "nonmember" : "anonymous";
    if (this.lmsUserService.IsLoggedIn) {
      let mbrTypes = this.lmsUserService.User.GetMemberTypes('ABMP');
      if (mbrTypes.includes('Certified') || mbrTypes.includes('Practitioner') || mbrTypes.includes('Professional') || mbrTypes.includes('PAC STAFF')) {
        variant = 'cpp';
      }
      if (mbrTypes.includes('Free Network') || mbrTypes.includes('Student')) {
        variant = 'student';
      }
    }
    return variant;
  }

  SwitchVariant(variant) {
    if (this.CanSwitchVariant()) {
      this.forcedVariant = variant;
    }
  }
}
